import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { lightGrey, grayDarkM, surfaceM, grayMediumHighlightM, primaryHighlightM, successM, white, backgroundMediumM, textPrimaryM, logoGreenM, grayLightM } from 'web-ui-kit/colors';
import { BodyBoldLargeStyles, BodySmallBoldLargeStyles } from 'web-ui-kit/typography';
import ModsyHeart from 'web-ui-kit/assets/ModsyHeart';
import ImageWithFallback from 'web-ui-kit/images/ImageWithFallback';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;

var DYNAMIC_STYLES = {
  'Exact match': {
    backgroundColor: grayDarkM,
    color: surfaceM
  },
  'New': {
    backgroundColor: grayMediumHighlightM,
    color: surfaceM
  },
  'Recommended': {
    backgroundColor: grayDarkM,
    color: surfaceM
  },
  'Revision requested': {
    backgroundColor: grayDarkM,
    color: surfaceM
  },
  'Sale': {
    backgroundColor: primaryHighlightM,
    color: surfaceM
  },
  'Stand-in': {
    backgroundColor: grayDarkM,
    color: surfaceM
  },
  'Selected layout': {
    backgroundColor: successM,
    color: white
  },
  'Curated': {
    backgroundColor: backgroundMediumM,
    color: textPrimaryM
  },
  'Made for you': {
    backgroundColor: grayDarkM,
    color: surfaceM
  },
  'Beta': {
    backgroundColor: logoGreenM,
    color: surfaceM
  },
  'Everyday deal': {
    backgroundColor: surfaceM,
    border: "1px solid ".concat(grayLightM),
    color: textPrimaryM
  },
  'In design': {
    backgroundColor: grayDarkM,
    color: surfaceM
  }
};

function Tag(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$category = _ref.category,
      category = _ref$category === void 0 ? '' : _ref$category,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Sale' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$imageData = _ref.imageData,
      imageData = _ref$imageData === void 0 ? {} : _ref$imageData;
  var text = type === 'Exact match' ? 'Your exact piece' : type;
  var imageSrc = imageData.imageSrc,
      alt = imageData.alt;
  var fallbackComponent =
  /*#__PURE__*/
  React.createElement(ModsyHeart, {
    variant: 'messengerProfilePic',
    margin: "0 4px 0 0"
  });
  var style = DYNAMIC_STYLES[category || type];
  return (
    /*#__PURE__*/
    React.createElement(TagBase, {
      className: className,
      size: size,
      style: style
    }, imageSrc &&
    /*#__PURE__*/
    React.createElement(Avatar, {
      alt: alt,
      bucketName: "modsy",
      fallbackComponent: fallbackComponent,
      src: imageSrc,
      width: 16,
      height: 16
    }), text)
  );
}

Tag.propTypes = {
  /** Allows extending styles with styled(Tag) constructor.
   * Useful for absolutely positioning the tag over an image.
  */
  className: PropTypes.string,

  /** The tag category. */
  category: PropTypes.oneOf(['', 'Curated']),

  /** The tag type */
  type: PropTypes.oneOf(['Exact match', 'New', 'Recommended', 'Revision requested', 'Sale', 'Stand-in', 'Selected layout', 'Top Pick', 'Made for you', 'In design']),

  /** The desired tag size */
  size: PropTypes.oneOf(['small', 'large']),

  /** Optional image */
  imageData: PropTypes.shape({
    imageSrc: PropTypes.string,
    alt: PropTypes.string
  })
};
/** These styles are common across tags */

var TagBase = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", ";\n\n  border-radius: 4px;\n  padding: 0.25rem 0.5rem;\n  white-space: nowrap;\n\n  ", "\n"])), function (p) {
  return p.size === 'large' ? BodyBoldLargeStyles : BodySmallBoldLargeStyles;
}, function (p) {
  return p.size === 'small' && "padding: 0.125rem 0.25rem;";
});
var AvatarImageStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  height: 1rem;\n  width: 1rem;\n  margin-right: 0.25rem;\n  border: 1px solid ", ";\n"])), lightGrey);
var Avatar = styled(ImageWithFallback)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), AvatarImageStyles);
export default Tag;